import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loader from 'react-loader';

class AsyncImage extends Component {
  static propTypes = {
    assetId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    thumb: PropTypes.bool,
    asyncUrlProvider: PropTypes.func.isRequired,
    showLoadingSpinner: PropTypes.bool,
    recolor: PropTypes.object
  };

  static defaultProps = {
    thumb: false,
    showLoadingSpinner: false
  };

  constructor(props) {
    super(props);

    this.state = {
      src: null
    };

    this.mounted = true;
  }

  componentDidMount() {
    this.getImageUrl(this.props.assetId);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.assetId !== nextProps.assetId) {
      this.setState({ src: null });
    }
    return true;
  }

  componentDidUpdate(prevProps) {
    const { assetId, recolor } = this.props;
    if (assetId !== prevProps.assetId || recolor !== prevProps.recolor) {
      this.getImageUrl(assetId);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  async getImageUrl(assetId) {
    const { asyncUrlProvider, thumb, contentType, recolor } = this.props;
    asyncUrlProvider(assetId, thumb, contentType, recolor).then(src => {
      if (this.mounted) {
        this.setState({ src });
      }
    });
  }

  render() {
    const { className, alt, showLoadingSpinner, assetId, draggable } = this.props;
    let { src } = this.state;

    if (!src) {
      if (showLoadingSpinner === true) {
        return <Loader loaded={false} />;
      }
      return null;
    }

    return (
      <img
        id={`img-${assetId}`}
        className={className}
        src={src}
        alt={alt}
        onMouseEnter={this.showTooltip}
        onMouseLeave={this.hideTooltip}
        draggable={draggable}
        crossOrigin="anonymous"
      />
    );
  }
}

export default AsyncImage;
